<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>快讯设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="page-content" shadow="never">
            <div class="page-actions">
                <el-select :value="query.language" @change="handleQueryChange('language', $event)" placeholder="请选择">
                    <el-option
                            v-for="item in languageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-plus" @click="handleCreate">添加</el-button>
            </div>
            <news-list @refresh="refreshList" :language = "query.language"></news-list>
        </el-card>
    </div>
</template>

<script>
    import './store';
    import NewsList from './components/list';
    import {mapActions, mapState, mapMutations} from 'vuex';

    export default {
        name: 'newsSetting',
        components: {
            NewsList,
        },
        computed: {
            ...mapState('newsSetting', ['languageList','query'])
        },
        methods: {
            ...mapActions('newsSetting', ['list','buildOpType']),
            ...mapMutations('newsSetting', ['changeQuery']),
            refreshList() {
                this.list(this.query);
            },
            handleQueryChange(type, value) {
                this.changeQuery({
                    ...this.query,
                    [type]: value
                });
                this.refreshList();
            },
            handleCreate(){
                this.buildOpType('insert');
                this.$router.push({ path: '/home/setting/news/editor' });
            }
        },
        created() {
            this.list(this.query);
        }
    };
</script>

<style lang="less" scoped>
</style>
